/**
 * 订单状态；1:下单，2:已接单，3:已预约，4:已拍摄，5:审核中，6:未通过官方审核，7:验收，8:验收未通过，9:订单完成，10:订单取消
 */
export const orderStatusOptions = [
  { key: '1', display_name: '下单', tag_type: 'warning' },
  { key: '2', display_name: '已接单', tag_type: '' },
  { key: '3', display_name: '已预约', tag_type: 'info' },
  { key: '4', display_name: '已拍摄', tag_type: 'info' },
  { key: '5', display_name: '待审核', tag_type: 'info' },
  { key: '6', display_name: '未通过官方审核', tag_type: 'danger' },
  { key: '7', display_name: '验收', tag_type: 'warning' },
  { key: '8', display_name: '验收未通过', tag_type: 'danger' },
  { key: '9', display_name: '订单完成', tag_type: 'success' },
  { key: '10', display_name: '订单取消', tag_type: 'info' },
  { key: '11', display_name: '用户申请取消订单', tag_type: 'info' },
  { key: '12', display_name: '待选片', tag_type: 'warning' },
  { key: '13', display_name: '已选片', tag_type: 'info' }
]

/**
 * 订单类型；1: 个人付费普通订单，2: 总部付费总部验收，3: 总部付费酒店验收，4: 第三方导入订单
 */
export const orderTypeOptions = [
  { key: '1', display_name: '个人付费普通订单', tag_type: 'info' },
  { key: '2', display_name: '总部付费总部验收', tag_type: 'info' },
  { key: '3', display_name: '总部付费酒店验收', tag_type: 'info' },
  { key: '4', display_name: '第三方导入订单', tag_type: 'info' }
]

/**
 * 支付状态；1: 未支付，2: 已支付，3: 退款申请，4: 退款失败，5: 退款成功
 */
export const payStatusOptions = [
  { key: '1', display_name: '未支付', tag_type: 'info' },
  { key: '2', display_name: '已支付', tag_type: 'success' },
  { key: '3', display_name: '退款申请', tag_type: 'warning' },
  { key: '4', display_name: '退款失败', tag_type: 'warning' },
  { key: '5', display_name: '退款成功', tag_type: 'info' },
  { key: '6', display_name: '退款中', tag_type: 'warning' },
]

/**
 * 订单来源；0: 去拍拍管家，1: 微信公众号，2: 小程序，3: 安卓，4: IOS，5: PC网站
 */
export const sourceIdOptions = [
  { key: '0', display_name: '去拍拍管家', tag_type: 'info' },
  { key: '1', display_name: '微信公众号', tag_type: 'info' },
  { key: '2', display_name: '小程序', tag_type: 'info' },
  { key: '3', display_name: '安卓', tag_type: 'info' },
  { key: '4', display_name: 'IOS', tag_type: 'info' },
  { key: '5', display_name: 'PC网站', tag_type: 'info' },
]

/**
 * 支付状态，1: 发起支付，2: 支付中，3: 支付成功，4: 支付失败，5: 支付取消，6: 支付返还
 */
export const paymentRecordStateOptions = [
  { key: '1', display_name: '发起支付', tag_type: 'info' },
  { key: '2', display_name: '支付中', tag_type: 'warning' },
  { key: '3', display_name: '支付成功', tag_type: 'success' },
  { key: '4', display_name: '支付失败', tag_type: 'danger' },
  { key: '5', display_name: '支付取消', tag_type: 'info' },
  { key: '6', display_name: '支付返还', tag_type: 'info' },
]

/**
 * 状态，1:提交退款，2:退款成功，3:退款失败，4:退款关闭
 */
export const refundRecordStateOptions = [
  { key: '1', display_name: '提交退款', tag_type: 'danger' },
  { key: '2', display_name: '退款成功', tag_type: 'success' },
  { key: '3', display_name: '退款失败', tag_type: 'warning' },
  { key: '4', display_name: '退款关闭', tag_type: 'info' },
]



// WEBPACK FOOTER //
// ./src/constant/enum/order.js